import util from '../util'

let controller = 'PerfilFrontEndScopes'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetScopesParceiro: function (codigoParceiro) {
    let dto = {
      parameters: [
        { name: 'codigoParceiro', value: codigoParceiro }
      ]
    }
    return util.Axios.GetAll(controller + '/GetScopesParceiro', dto)
  }
})
